export const removeSuccessToast = {
  title: '削除されました $t(tracker:displayKind, {"context": "{{context}}" })',
};
